import { render, staticRenderFns } from "./BundleSimple.vue?vue&type=template&id=0b3fdeae&scoped=true"
import script from "./BundleSimple.vue?vue&type=script&lang=js"
export * from "./BundleSimple.vue?vue&type=script&lang=js"
import style0 from "./BundleSimple.vue?vue&type=style&index=0&id=0b3fdeae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3fdeae",
  null
  
)

export default component.exports